import { Component, HostBinding, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'suka-card-section',
  template: `
    <ng-content></ng-content>
  `,
  encapsulation: ViewEncapsulation.None,
})
export class CardSection {
  @HostBinding('class.card-section') cardSectionClass = true;
}
